import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-certificate-input',
  templateUrl: './certificate-input.component.html',
  styleUrls: ['./certificate-input.component.scss'],
  standalone: false
})
export class CertificateInputComponent implements OnInit, OnDestroy {
  @Input()
  public name: string;

  @Input()
  public placeholder = '-----BEGIN CERTIFICATE-----\n...';

  @Input()
  public bold = false;

  @Input()
  public control: FormControl;

  @Input()
  public canDownload: boolean;

  @Output()
  public download = new EventEmitter<void>();

  public busy = false;
  public copied = false;
  public uploadError = false;
  private controlSubscription: Subscription;

  public ngOnInit(): void {
    this.controlSubscription = this.control.valueChanges.subscribe(() => {
      if (this.uploadError) {
        this.uploadError = false;
      }
    });
  }

  public ngOnDestroy(): void {
    if (this.controlSubscription) {
      this.controlSubscription.unsubscribe();
    }
  }

  public onCertInput(event: any): void {
    if (!event || !event.target.files || event.target.files.length === 0) {
      return;
    }
    this.busy = true;
    const fr = new FileReader();
    const [file] = event.target.files;

    fr.readAsText(file);
    fr.onload = (loadEvent: ProgressEvent<FileReader>) => {
      this.control.setValue(loadEvent.target.result as string);
      this.control.markAsDirty();
      this.busy = false;
    };

    fr.onerror = (errorEvent: ProgressEvent<FileReader>) => {
      console.error(errorEvent.target.error);
      this.uploadError = true;
      this.busy = false;
    };
  }
}
